import { clampNormRect } from "../editor/coords.js";
import { getCompositionSpec, } from "../style/composition.js";
export function getEffectiveCalmZones(slide, theme) {
    const measured = slide.background.freeZones?.filter((z) => z.w > 0 && z.h > 0);
    if (measured?.length)
        return measured;
    const spec = getCompositionSpec(slide.composition);
    if (spec.calmZones.length)
        return spec.calmZones;
    return theme.legibility.safeZones;
}
export function effectiveThemeForSlide(theme, slide) {
    const zones = getEffectiveCalmZones(slide, theme);
    if (!zones.length)
        return theme;
    return {
        ...theme,
        legibility: {
            ...theme.legibility,
            safeZones: zones,
        },
    };
}
export function compositionScrimForSlide(slide) {
    return getCompositionSpec(slide.composition).scrim;
}
/** Clamp text layer rects inside the primary calm zone. */
export function clampSlotsToCalmZones(slide, calmZones) {
    if (!calmZones.length)
        return slide;
    const zone = calmZones[0];
    const layers = slide.layers.map((layer) => {
        if (layer.type !== "text")
            return layer;
        return {
            ...layer,
            ...clampNormRect({
                x: Math.max(zone.x, Math.min(layer.x, zone.x + zone.w - layer.w)),
                y: Math.max(zone.y, Math.min(layer.y, zone.y + zone.h - layer.h)),
                w: Math.min(layer.w, zone.w),
                h: Math.min(layer.h, zone.h),
            }),
        };
    });
    return { ...slide, layers };
}
export function applyCompositionToSlide(slide, kind, _theme) {
    const spec = getCompositionSpec(kind);
    // Changing composition invalidates the cached auto-prompt and the saliency
    // measured from the previous background, otherwise regeneration reuses the
    // old prompt (resolveSlideImagePrompt) and the old freeZones override the new
    // composition zones — neither background nor text would move.
    let next = {
        ...slide,
        composition: kind,
        background: {
            ...slide.background,
            prompt: undefined,
            freeZones: undefined,
            busyRegions: undefined,
        },
    };
    if (spec.calmZones.length) {
        next = clampSlotsToCalmZones(next, spec.calmZones);
    }
    if (spec.scrim !== "none") {
        const hint = spec.scrim === "strong" ? "strong" : "soft";
        next = {
            ...next,
            layers: next.layers.map((layer) => layer.type === "text"
                ? { ...layer, style: { ...layer.style, scrimHint: hint } }
                : layer),
        };
    }
    return next;
}
